import {ADataGridColumn} from "@atiautomacao/ati-ui-library";

export const performanceAnalysisColumns = [
    {
        name: 'status',
        label: 'Status',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'powerStationName',
        label: 'UFV',
        align: 'left',
        minWidth: 50,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'powerCapacityNominal',
        label: 'kWp',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'instantPower',
        label: 'Potência (kW)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'irradianceSum',
        label: 'Irradiação (kWh/m²)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'generatedEnergySum',
        label: 'Energia (MWh)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'performanceRatio',
        label: 'PR (%)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
    {
        name: 'availability',
        label: 'Disponibilidade (%)',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
    },
] as ADataGridColumn[];
